import React, { useState, useEffect } from "react";
import { Modal, Button, Space, Card, Row, Col, Checkbox } from "antd";
import ColumnModal from "./Modal/columnModal";
import styles from "./ProfileStyle.module.css";
import { connect } from "react-redux";

const buttonStyle = {
  margin: "40px",
};

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const budget_table_columns = [
  {
    title: "BOQ Item",
    key: "boq_item",
  },
  {
    title: "Category",
    key: "category_name",
  },
  {
    title: "Item Description",
    key: "item_description",
  },
  {
    title: "Quantity",
    key: "quantity",
  },
  {
    title: "Unit",
    key: "unit",
  },
  {
    title: "Unit",
    key: "unit",
  },
  {
    title: "Sales Price",
    key: "boq_price",
  },
  {
    title: "Target Price",
    key: "budget_price",
  },
  {
    title: "Absolute Margin",
    key: "absolute_margin",
  },
  {
    title: "Gross Margin",
    key: "gross_margin",
  },
  {
    title: "Tax type",
    key: "tax_type",
  },
  {
    title: "Tax value",
    key: "tax_value",
  },
];

const TableSettings = (props) => {
  const tableData = {
    budget: [
      "BOQ Item",
      "Category",
      "Item Description",
      "Qty",
      "Unit",
      "Make/Brand",
      "BOQ Price",
      "Budget Price",
      "Utilized Budget",
      "Pending Budget",
      "Tax",
      "PO Price",
      "Remarks",
      "PO status",
    ],
    approvalByMe: [
      "PO Number",
      "Project",
      "Vendor",
      "Delivery Date",
      "Creation Date",
      "Total",
      "Vendor Name",
      "Order Type",
      "Status",
      "See Details",
    ],
    approvalForMe: [
      "PO Number",
      "Project",
      "Vendor",
      "Requested By",
      "Delivery Date",
      "Creation Date",
      "Total",
      "See Details",
      "Approve",
      "Reject",
    ],
    powo: [
      "PO Number",
      "Vendor Name",
      "Delivery Date",
      "Creation Date",
      "Created By",
      "Order Type",
      "Status",
      "Total",
    ],
    vendors: [
      "Vendor Code",
      "Vendor Name",
      "Vendor Type",
      "Contact Person",
      "Mobile Number",
      "Email ID",
    ],
    vendorsPOAmount: [
      "Vendor Code",
      "Vendor Name",
      "Vendor Type",
      "Total Amount",
      "Number of POs",
    ],
  };
  const [modalVisible, setModalVisible] = useState(false);
  const [currentTableColumns, setCurrentTableColumns] = useState([
    { tableName: "budget", columns: [] },
    { tableName: "approvalByMe", columns: [] },
    { tableName: "approvalForMe", columns: [] },
    { tableName: "powo", columns: [] },
    { tableName: "vendors", columns: [] },
    { tableName: "vendorsPOAmount", columns: [] },
  ]);
  const [click, setClick] = useState("");
  const [tableColumns, setTableColumns] = useState([]);
  const handleClick = (key) => {
    setModalVisible(true);
    setClick(key);
    setTableColumns(tableData[key]);
  };

  useEffect(() => {
    if (props.tableColumns && props.tableColumns !== []) {
      setCurrentTableColumns(props.tableColumns);
    }
  }, []);
  return (
    <div className={styles.tableComponent}>
      <h5>Change Table settings</h5>
      <br></br>
      <div className={styles.columnsCards}>
        <Row gutter={16}>
          <Col span={8} style={{ paddingBottom: "30px" }}>
            <Card
              title="Budget"
              extra={
                <Button
                  type="primary"
                  id="budget"
                  onClick={() => handleClick("budget")}
                >
                  Edit
                </Button>
              }
              style={{ width: 300 }}
            >
              {currentTableColumns[0].columns.map((e, idx) => (
                <p key={idx}>{e}</p>
              ))}
            </Card>
          </Col>

          <Col span={8} style={{ paddingBottom: "30px" }}>
            <Card
              title="Approval By Me"
              extra={
                <Button
                  type="primary"
                  id="approvalByMe"
                  onClick={() => handleClick("approvalByMe")}
                >
                  Edit
                </Button>
              }
              style={{ width: 300 }}
            >
              {currentTableColumns[1].columns.map((e, idx) => (
                <p key={idx}>{e}</p>
              ))}
            </Card>
          </Col>

          <Col span={8} style={{ paddingBottom: "30px" }}>
            <Card
              title="Approval For Me"
              extra={
                <Button
                  type="primary"
                  id="approvalForMe"
                  onClick={() => handleClick("approvalForMe")}
                >
                  Edit
                </Button>
              }
              style={{ width: 300 }}
            >
              {currentTableColumns[2].columns.map((e, idx) => (
                <p key={idx}>{e}</p>
              ))}
            </Card>
          </Col>

          <Col span={8} style={{ paddingBottom: "30px" }}>
            <Card
              title="Powo"
              extra={
                <Button
                  type="primary"
                  id="powo"
                  onClick={() => handleClick("powo")}
                >
                  Edit
                </Button>
              }
              style={{ width: 300 }}
            >
              {currentTableColumns[3].columns.map((e, idx) => (
                <p key={idx}>{e}</p>
              ))}
            </Card>
          </Col>

          <Col span={8} style={{ paddingBottom: "30px" }}>
            <Card
              title="vendors"
              extra={
                <Button
                  type="primary"
                  id="vendors"
                  onClick={() => handleClick("vendors")}
                >
                  Edit
                </Button>
              }
              style={{ width: 300 }}
            >
              {currentTableColumns[4].columns.map((e, idx) => (
                <p key={idx}>{e}</p>
              ))}
            </Card>
          </Col>

          <Col span={8} style={{ paddingBottom: "30px" }}>
            <Card
              title="Vendors PO Amount"
              extra={
                <Button
                  type="primary"
                  id="vendorsPOAmount"
                  onClick={() => handleClick("vendorsPOAmount")}
                >
                  Edit
                </Button>
              }
              style={{ width: 300 }}
            >
              {currentTableColumns[5].columns.map((e, idx) => (
                <p key={idx}>{e}</p>
              ))}
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        width={"80vw"}
        title={`Change table display settings`}
        centered
        visible={modalVisible}
        onOk={() => {
          setModalVisible(false);
        }}
        onCancel={() => setModalVisible(false)}
      >
        <Card></Card>
      </Modal>
    </div>
  );
};

export default connect(mapStateToProps)(TableSettings);
